import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Division } from './entities/division-entity';
import { Repository } from 'typeorm';
import { DivisionUnitResponse, DivisionUserDetails, UserIdReq } from '@analytics-soa/shared-models';

@Injectable()
export class ClientConfigurationsService {
    constructor(
        @InjectRepository(Division) private readonly divisionRepository: Repository<Division>,
    ) { }

    async findAllDivisions() {
        const divisions = await this.divisionRepository.find({
            where: {
                // isActive: true
            }
        });
        return divisions.map(division => ({ value: division.id, label: division.divisionName, code: division.divisionCode, color: division.repColor }));
    }
    async getDivisionForUserId(req:UserIdReq):Promise <DivisionUnitResponse>{
        
            const query = this.divisionRepository.createQueryBuilder('d').select('d.id AS divisionId , d.division_name AS divisionName , d.division_code AS divisionCode , ud.user_id AS userId , u.username')
            .leftJoin(`user_to_division_map`, `ud`, 'ud.`division_id` = d.`id`')
            .leftJoin(`user`, `u`, 'u.`id` = ud.`user_id`')
            .where(`ud.user_id = '${req.userId}'`);
            const data: DivisionUserDetails[] = await query.getRawMany();
        if (data) {
            console.log(data);
            return new DivisionUnitResponse(true, 0, 'Data Retrieve Successfully', data)
        } else {
            return new DivisionUnitResponse(false, 0, "Something went wrong")
        }
    }
        
}
